// @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'RecentlyVisitedEvent'. Did you mean to use 'import RecentlyVisitedEvent from "src/api-parsers/index"' instead?
import type {RecentlyVisitedEvent} from 'src/api-parsers/index';

import keyBy from 'lodash/keyBy';

import type {State} from 'src/reducers';


export const selectRecentlyVisitedEvents = (
  state: State,
): {
  [eventId: string]: RecentlyVisitedEvent;
} => {
  const recentlyVisitedEvents =
    state.agencyOverview?.data.recentlyVisitedEvents || [];

  return keyBy(recentlyVisitedEvents, 'event_id');
};

export const selectNpsData = (
  state: State,
):
  | {
      detractors: number;
      passive: number;
      promoters: number;
      score: number;
    }
  | null
  | undefined => state.agencyOverview?.data.nps;
